import ArticleTheme from './article';
import BubbleTheme from './bubble';
import extend from "extend";

class StoryTheme extends ArticleTheme {}

StoryTheme.DEFAULTS = extend(true, {}, BubbleTheme.DEFAULTS, {
  modules: {
    embedButtons: ['img', 'gallery', 'embed', 'divider']
  }
});

export default StoryTheme;
